import { notify, RedeemCodeModal } from "@housebets/housebets-x-package"
import { useState } from "react";
import { useIntl } from "react-intl";
import apiAffiliate from "app/api/affiliate";
import { IRedeemModalProps } from "./types";
import { useGTMEvents } from "app/hooks/useGTMEvents";

export const RedeemModal: React.FC<IRedeemModalProps> = ({ isOpen, setIsOpen }) => {
    const [code, setCode] = useState("");
    const [isRedeemLoading, setIsRedeemLoading] = useState(false);
    const { modal } = useGTMEvents();
    const { $t } = useIntl();

    const getBonusCodeRewards = async (code: string) => {
        if (isRedeemLoading) return;
        setIsRedeemLoading(true);
        try {
            const res = await apiAffiliate.getBonusCodeRewards(code);
            if (res.status === 200 && res.data.code === 0) {
                notify({
                    type: "success",
                    title: $t({ id: `PROMO_CODE_MESSAGE${res.data.code}` }),
                });
                setCode("");
                setIsOpen(false)
                return;
            }
            notify({
                type: "error",
                title: $t({ id: `PROMO_CODE_MESSAGE${res.data.code}` }),
            });
        } finally {
            setIsRedeemLoading(false);
        }
    };

    return (
        <RedeemCodeModal
            loading={isRedeemLoading}
            onCodeChange={(code) => { setCode(code) }}
            onSubmit={() => getBonusCodeRewards(code)}
            text={{
                buttonText: "Redeem",
                label: $t({ id: "EnterPromoCode" }),
                placeholder: $t({ id: "EnterPromoCode" }),
                title: $t({ id: "RedeemCode" })
            }}
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            afterOpenModal={() => {
                modal.show('redeem_code')
            }}
            onAfterClose={() => {
                modal.close('redeem_code')
            }}
        />
    )
}

RedeemModal.displayName = 'RedeemModal';